import React from 'react'
import classnames from 'classnames'
import SVG from 'react-inlinesvg'
import successIcon from '@icons/success/green'

const InputGroup = ({
  id, label, error, touched, className,
  hint, successHighlighting, Component, enforceSuccess, ...props
}) => {
  const success = !!successHighlighting && touched && !error && (props.value || enforceSuccess);
  const classes = classnames(
    'input-group',
    {
      'input-group--invalid': !!error,
      'input-group--success': success
    },
    className
  );

  return (
    <div className={classes}>
      { label ? (
          <label className="form-label" htmlFor={id} error={error}>
            {label}
          </label>
        ) : null
      }

      <div className="text-input--wrapper">
        <Component id={id} {...props} />

        { success ? (
            <div className="text-input__append">
              <SVG src={successIcon} />
            </div>
          ) : null
        }
      </div>

      { hint && (<div className="help-inline">{ hint }</div>) }

      {
        !!error && (
          <div className="help-inline help-inline--invalid">
            { error }
          </div>
        )
      }
    </div>
  );
};

InputGroup.defaultProps = {
  successHighlighting: false
}

export default InputGroup
